export const getThumbnailUrlByCid = (cid, width) => {
  return `https://ipfs-imgix.ebo.io/ipfs/${cid}?ar=16:9&fit=fill&max-w=${width}&auto=format`
}